<template>
	<div class="post-block-list post-module-1 col-lg-4 col-md-6 mb-30">
		<div style="margin-top: 2.5rem;" class="news-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="news-title-bg">
			Featured Information
		</div>
	    <ul class="list-post" style="margin-top: 1rem;">
	        <li class="mb-20 wow fadeInUp animated"v-for="(item, index) in hotData" @click="tonewsdetail(item.id)">
	            <div class="d-flex bg-white has-border p-25 hover-up transition-normal border-radius-5" style="cursor: pointer;">
	                <div class="post-content media-body">
	                    <h6 class="post-title mb-15 text-limit-2-row font-medium text-hover" style="font-size: 1rem;">{{item.title}}</h6>
	                    <div class="entry-meta meta-1 float-left font-x-small text-uppercase">
	                        <!-- <span class="post-on">{{item.createdAt|format}}</span> -->
	                        <span class="post-by">{{item.browseCount}} views</span>
	                    </div>
	                </div>
	                <div class="post-thumb post-thumb-80 d-flex ml-15 border-radius-5 img-hover-scale overflow-hidden" >
	                    <span class="color-white">
	                        <!-- <img :src="hotData.items[0].coverImage" alt=""> -->
						<div  :style="{backgroundImage: 'url('+item.coverImage+')'}"  class="news-img-box"></div>
	                    </span>
	                </div>
	            </div>
	        </li>
	    </ul>
	</div>
</template>

<script>
	
			import axios from 'axios'
			import {baseUrl} from '../../assets/js/public.js'
			export default {
				data() {
					return {
						hotData:[]
					}
				},
				props:{
				},
				components: {
				},
				filters: {
				},
				methods: {
					getHotData(){
						let perPage = 6
						this.request({
							method: 'get',
							url: '/gci/article/list?orderBy=isHot&perPage='+perPage,
						}).then(res => {
							this.hotData = res.data.items
						}).catch(error => {
							console.error(error.response)
						})
					},
					tonewsdetail(id){
						this.$router.push({name:'newsdetail',query:{id:id}})
						location.reload();
						// this.$router.go()
					}
				},
				mounted() {
					this.getHotData()
				}
			}
</script>

<style scoped lang="scss">
li{list-style:none}
	.news-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		.news-title-bg{
			width: 13rem;z-index: -1;position: absolute;left: 0.5rem;top: 1rem
		}
	}
	
	.news-img-box{
		background-size:cover;
		background-repeat: no-repeat;
		background-position: top center ;
		width: 5.625rem;
	    height: 5rem;
		transition: transform .5s;
	}
	.news-img-box:hover{
		    -webkit-transform: scale(1.1);
		    -ms-transform: scale(1.1);
		    transform: scale(1.1);
		    -webkit-transition: -webkit-transform .5s;
		    transition: -webkit-transform .5s;
		    -o-transition: transform .5s;
		    transition: transform .5s;
		    transition: transform .5s,-webkit-transform .5s;
	}
	
</style>